import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import uiPagination from 'angular-ui-bootstrap/src/pagination';
import {PregledComponent} from './pregled.component.js';
import {GridComponent} from './grid/grid.js';
import FormComponent from './form/form.js';

const pregled = angular.module('pregled', [uiModal, uiPagination, 'mgo-angular-wizard']);

pregled.component('pregled', PregledComponent);
pregled.component('pregledForm', FormComponent);
pregled.component('pregledGrid', GridComponent);

export {pregled};



// WEBPACK FOOTER //
// ./app/components/pregled/pregled.js